/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/

import Cookies from "js-cookie";
import AppRoutes from "./routes/routes";
import { LicenseInfo } from '@mui/x-license';
import { CookiesConsent } from "./components/cookiesConsent/cookiesConsent";
import { TimerValusSets } from "./context/TimerContext";
import { muiLicense } from './constants/env-url';

function App() {

  const enableCookie = Cookies.get("enableCookies")
  let date = new Date();
  let days: any = 365;
  date.setTime(+ date + (days * 86400000));

  LicenseInfo.setLicenseKey(muiLicense || '');
  return (
    <div >
      {
        ((enableCookie === undefined || enableCookie === null || enableCookie == "false")) &&
        <CookiesConsent />
      }
      <TimerValusSets>
        <div>
          <AppRoutes />
        </div>
      </TimerValusSets>
    </div>
  );
}

export default App;
